import { makeAutoObservable } from "mobx";
import { apiLink } from "../helpers/constantVariables";
import { apiPostPut } from "../api/api_methods";

class FeedbackStore {
  constructor() {
    makeAutoObservable(this);
  }

  async postSuggestionToApi(body) {
    const user = localStorage.getItem("user");
    // console.log(JSON.parse(user), "user");
    const userId = JSON.parse(user);
    // const mediaLength = body.media.length;
    const mediaData = [];
    // console.log(body.media, "body.media");
    if (body.media && Array.isArray(body.media)) {
      for (let i = 0; i < body.media?.length; i++) {
        if (body.media[i]) {
          mediaData.push({
            mediaType: "image",
            mediaUrl: body.media[i].url,
          });
        }
      }
    }
    const PostData = {
      subject: body.subject,
      body: body.body,
      suggestionFor: "bug",
      // media: body?.media?.[0]
      //  ? mediaData : [],
      media: mediaData ? mediaData : [],
      uDetails: {
        _id: userId?._id,
      },
    };
    const response = await apiPostPut(
      PostData,
      "/suggestion/new-suggestion",
      "POST"
    );
    if (response.status === 200) {
      return true;
    } else {
      alert("something went wrong");
      return false;
    }
  }
}
export default FeedbackStore;
